// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const BlockIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="BlockIcon" ref={forwardedRef} {...props}>
      <path d="M1.996 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0m2.93 4.067a6.5 6.5 0 0 1 9.138-9.138zm1.066 1.054 9.125-9.125A6.47 6.47 0 0 1 16.497 10a6.49 6.49 0 0 1-2.44 5.075 6.47 6.47 0 0 1-4.06 1.425 6.48 6.48 0 0 1-4.005-1.379" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const BlockIcon = /* @__PURE__ */ Object.assign(BlockIconComponent, {
  displayName: 'BlockIcon',
});
